import { createContext, useContext, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useCommonStyles } from '../styles/GenericStyle';

type DialogContextValue = {
  confirm: (opts: any) => void;  
};
type ConfirmResult = boolean;

const ConfirmDialogContext = createContext<DialogContextValue | null>(null);

export const useConfirm = (): DialogContextValue => {
  const ctx = useContext(ConfirmDialogContext);
  if (ctx === null) {
    throw new Error("useSnackbar must be used within <SnackbarProvider>");
  }
  return ctx;
};





export const ConfirmDialogProvider:React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const resolveRef = useRef<((result: ConfirmResult) => void) | null>(null);
 const classes = useCommonStyles();
  const [state, setState] = useState<{
    open: boolean;
    title: React.ReactNode;
    description: React.ReactNode;
    confirmText: string;
    cancelText: string;
    severity: string;
  }>({
    open: false,
    title: "",
    description: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
    severity: "primary",
  });

  const confirm = ({
    title = "Are you sure?",
    description = "",
    confirmText = "Confirm",
    cancelText = "Cancel",
    severity = "primary",
  } = {}) => {
    setState({
      open: true,
      title,
      description,
      confirmText,
      cancelText,
      severity,
    });

    return new Promise((resolve) => {
      resolveRef.current = resolve;
    });
  };

  const handleClose = (result:any) => {
    setState((prev) => ({ ...prev, open: false }));
    resolveRef.current?.(result);
  };

  return (
    <ConfirmDialogContext.Provider value={{ confirm }}>
      {children}

      <Dialog
        open={state.open}
        onClose={() => handleClose(false)}
        maxWidth={false}
        PaperProps={{ sx: { width: 640, borderRadius: 3, p: 1 } }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 1, pt: 1 }}>
          <IconButton aria-label="close" size="small" onClick={() => handleClose(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        {state.title && <DialogTitle sx={{ pt: 0 }}>{state.title}</DialogTitle>}

        <DialogContent sx={{ pt: state.title ? 1 : 0 }}>
          <Typography component="div">{state.description}</Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => handleClose(false)}  variant="contained"   className={classes.whiteButton}   >
            {state.cancelText}
          </Button>

          <Button
            variant="contained"           
            onClick={() => handleClose(true)} sx={{borderRadius:"8px"}}  className={classes.greenButton}>
            {state.confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmDialogContext.Provider>
  );
};
